import { render, staticRenderFns } from "./UiOverlayLoader.vue?vue&type=template&id=48b6f725&scoped=true"
import script from "./UiOverlayLoader.vue?vue&type=script&lang=js"
export * from "./UiOverlayLoader.vue?vue&type=script&lang=js"
import style0 from "./UiOverlayLoader.vue?vue&type=style&index=0&id=48b6f725&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b6f725",
  null
  
)

export default component.exports